import React from 'react'

const ButtonComponent = ({ onMouseDown, height, width }) => (
  <button className="button-container" onMouseDown={onMouseDown}  style={{height:height, width:width}}>Join waitlist</button>
)

export default ButtonComponent
